(ns practitest.frontend.searchable-tree
  (:require
    [practitest.frontend.pt-ts-bridge :as pt-ts :refer [GenericSearchableTree]]
    [clojure.string :as str]
    [goog.dom :as gdom] 
    [practitest.frontend.common.utils :as utils]
    [practitest.frontend.components2.components-provider :refer [application-provider]]
    [practitest.frontend.init :as init]))

(defn- valid-json?
  [s]
  (and (some? s)
       (not (str/blank? s))
       ;; Ignore unevaluated mustache templates
       (not (str/starts-with? s "{{"))))

(defn- try-parse-json
  [s]
  (try
    (when (valid-json? s)
      (js/JSON.parse s))
    (catch js/Error e 
      nil)))

(defn generic-tree-root [{:keys [data-scope
                                 data-module
                                 disabled,
                                 data-initial-selected-item
                                 data-urls 
                                 data-custom-class-name
                                 data-selected-value
                                 data-notify-event 
                                 data-on-change]
                          :as attrs}]
  
  (let [scope (try-parse-json data-scope)
        initial-selected-item (try-parse-json data-initial-selected-item)
        module (when-not (str/blank? data-module)
                 data-module)
        urls (try-parse-json data-urls)
        notify-event (try-parse-json data-notify-event)
        custom-class-name data-custom-class-name
        selected-value  data-selected-value
        handle-change data-on-change
        disabled disabled]
    [application-provider
     [:> GenericSearchableTree
      {:onChange handle-change
       :initialSelectedItem initial-selected-item
       :customClassName custom-class-name
       :notifyEvent notify-event
       :selectedValue selected-value
       :disabled disabled
       :urls urls
       :scope scope}]]))

(defn clone-styles! [shadow-root]
  (when-let [style-element (gdom/getElement "pt-st-stylesheet")]
    (let [cloned-styles (.cloneNode style-element true)]
      ;; Copy all styles including media queries and imports
      (set! (.-textContent cloned-styles)
            (reduce (fn [acc sheet]
                      (str acc "\n" (.-cssText sheet)))
                    ""
                    (array-seq (.. style-element -sheet -cssRules))))
      ;; Append cloned styles to shadow root
      (.appendChild shadow-root cloned-styles))))

(defn ^:export init-generic-tree [webcomponent options]
  (let [shadow-root (.-shadowRoot webcomponent)]
    ;; Clone styles first
    (clone-styles! shadow-root)
    ;; Then initialize UI
    (init/init-ui! {:options      options
                    :webcomponent webcomponent
                    :root-view    generic-tree-root})))

(defn ^:dev/after-load remount-roots []
  (init/remount-roots "searchable-tree-component"
                      generic-tree-root))

(utils/register-webcomponent! "searchable-tree-component")